import React from 'react'

const ProfilePic = () => {
    return (
       
        
           <div className="text-center ">
             
         <img src="https://source.unsplash.com/random/300x300" className="profile-image" alt="..."/>
         </div>
   
    )
}

export default ProfilePic
